import { useEffect, useState } from 'react'
import { Card, Form, Input, Button, Typography, Space } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import * as auth from '../redux/actions'
import { ISettingTypeState } from 'src/app/modules/siteSettings/components/settings'
import { isEmpty } from 'lodash'

const { Title, Text } = Typography

export function InstantOtpValidation() {
  const [form] = Form.useForm()
  const params: any = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const authResp = useSelector((state: any) => state.auth)
  const settingTypeData: ISettingTypeState = useSelector(
    (state: any) => state.settingType
  )

  const loading = authResp?.loading

  const [timer, setTimer] = useState<number>(120)
  const [count, setCount] = useState<number>(120)

  // Redirect if email not present
  useEffect(() => {
    if (!params.state?.email) {
      history.push('/')
    }
  }, [params, history])

  // Fetch user after OTP success
  useEffect(() => {
    if (authResp?.accessToken) {
      dispatch(auth.actions.requestUser(authResp?.accessToken))
    }
  }, [authResp?.accessToken, dispatch])

  // Get resend time from backend settings
  // useEffect(() => {
  //   if (!isEmpty(settingTypeData?.backendData)) {
  //     const smtpSettings = settingTypeData?.backendData['SMTP Settings']
  //     const resendTime = smtpSettings?.find(
  //       (item: any) => item?.name === 'otpResendTime'
  //     )?.value

  //     if (resendTime) {
  //       setTimer(Number(resendTime))
  //       setCount(Number(resendTime))
  //     }
  //   }
  // }, [settingTypeData])

  // Countdown Timer
  useEffect(() => {
    if (count <= 0) return

    const interval = setInterval(() => {
      setCount((prev) => prev - 1)
    }, 1000)

    return () => clearInterval(interval)
  }, [count])

  const handleSubmit = (values: { token: string }) => {
    dispatch(auth.actions.otpVerify(values.token, params?.state?.email))
  }

  const handleResendOTP = () => {
    dispatch(auth.actions.resendOtp(params?.state?.email))
    setCount(timer)
    form.resetFields()
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f5f5f5',
      }}
    >
      <Card
        style={{ width: 400 }}
        bordered={false}
        className="shadow-md"
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={3}>OTP Verification</Title>
            <Text type="secondary">
              Enter the 6-digit OTP sent to your email
            </Text>
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
          >
            <Form.Item
              label="Enter OTP"
              name="token"
              rules={[
                { required: true, message: 'OTP is required' },
                { len: 6, message: 'OTP must be 6 digits' },
              ]}
            >
              <Input.OTP
                length={6}
                autoFocus
              />
            </Form.Item>

            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              {count > 0 ? (
                <Text type="secondary">
                  OTP expires in <b>{count}s</b>
                </Text>
              ) : (
                <Button type="link" onClick={handleResendOTP}>
                  Resend OTP
                </Button>
              )}
            </div>

            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
            >
              Verify OTP
            </Button>

            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <Link to="/  ">
                <Text type="secondary">Go back to Login</Text>
              </Link>
            </div>
          </Form>
        </Space>
      </Card>
    </div>
  )
}